import { $authHost } from "./index";

export const fetchChangeLogs = async (params = {}) => {
    const { data } = await $authHost.get('api/changelog', { params });
    return data;
}

export const fetchRecentChangeLogs = async (limit = 50) => {
    const { data } = await $authHost.get('api/changelog/recent', { params: { limit } });
    return data;
}

export const clearChangeLogs = async () => {
    const { data } = await $authHost.delete('api/changelog/clear');
    return data;
}

export const rollbackChangeLog = async (id) => {
    const { data } = await $authHost.post(`api/changelog/${id}/rollback`);
    return data;
}
